module.exports = __webpack_public_path__ + "static/img/bg-overview@m.10e123b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/genesis-shop/bg-overview@m.jpg
// module id = qAgx
// module chunks = 0